export default __webpack_public_path__ + "static/media/bathroom1.3f48dc6f.png";